// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__15BcX","left":"styles_left__1HaYM"};